import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const translations = {
  en: {
    // Navigation
    nav: {
      home: "Home",
      diensten: "Services",
      projecten: "Projects",
      vacatures: "Vacancies",
      contact: "Contact",
      brandblussystemen: "Fire Extinguisher Systems",
      branddetectie: "Fire Detection & Alarm Systems",
      onderhoud: "Maintenance & Inspection",
      advies: "Consulting & Fire Prevention",
      noodverlichting: "Emergency Lighting & Evacuation"
    },
    // Visual Highlights
    visualHighlights: [
      "Fire extinguisher inspection",
      "Fire safety control",
      "Fire protection equipment"
    ],
    // Hero
    hero: {
      headline: ["Professional", "fire protection,", "today and tomorrow."],
      description: "Leading fire protection services in Suriname. Proactive awareness and responsible action are the most effective defense against fire hazards.",
      cta: "GET A QUOTE"
    },
    // Company Intro
    companyIntro: {
      title: "PROSAFE FIRE PROTECTION N.V.",
      paragraph1: "Prosafe Fire Protection N.V. is the leading fire prevention company in Suriname, specializing in professional fire protection services. We support organizations in protecting people, buildings, and business continuity through reliable and certified fire safety systems.",
      paragraph2: "With an expert team and years of experience in fire suppression system installation and fire extinguisher maintenance, we offer solutions that meet international standards and local regulations. Our approach is practical, customer-oriented, and focused on long-term safety."
    },
    // Trusted Clients
    trustedClients: {
      title: "OUR TRUSTED CLIENTS"
    },
    // Why Prosafe
    whyProsafe: {
      title: "WHY PROSAFE FIRE PROTECTION?",
      reasons: [
        "Experienced and certified fire protection specialists",
        "Customized fire suppression system installation",
        "Fast service and fire extinguisher maintenance support",
        "Focus on fire prevention and business continuity"
      ]
    },
    // Mission & Vision
    missionVision: {
      missionTitle: "OUR MISSION",
      missionText: "To deliver high-quality fire protection services Suriname that minimize risks and contribute to a safe working environment for everyone through expert fire detection systems and fire suppression solutions.",
      visionTitle: "OUR VISION",
      visionText: "A society where fire protection Suriname is self-evident and organizations have confidence in their fire detection systems and fire suppression solutions."
    },
    // Core Values
    coreValues: {
      title: "Our Core Values",
      values: [
        { title: "Safety", description: "Fire prevention is always our highest priority" },
        { title: "Reliability", description: "Trusted fire protection services - a promise is a promise" },
        { title: "Professionalism", description: "Expert fire detection systems, certified, and transparent" },
        { title: "Quality", description: "Durable and proven fire suppression system installation" }
      ]
    },
    // CTA Section
    cta: {
      headline: ["CONTACT", "US", "TODAY"],
      headlineFull: "CONTACT US TODAY",
      description: "Request a free, no-obligation quote on fire suppression system installation and fire extinguisher maintenance.",
      button: "CONTACT"
    },
    // CTA for Brandblussystemen page
    ctaBrandblussystemen: {
      headline: "CONTACT US TODAY",
      description: "Get a Quote on Fire Protection Services Suriname",
      button: "GET A QUOTE"
    },
    // Footer
    footer: {
      subscriptionText: "Stay informed about fire protection Suriname. Subscribe to our newsletter for updates on fire prevention, fire detection systems, and practical fire safety insights—directly in your inbox.",
      copyright: "Copyright © 2026 Prosafe Fire Protection. All rights reserved."
    },
    // Projects Page
    projects: {
      title: "PROJECTS",
      subtitle: "Showcasing our commitment to safety through successful fire protection implementations.",
      paragraph1: "Our project portfolio highlights the ability of Prosafe to deliver tailored fire protection systems that meet stringent performance standards and client needs. These include the sale and certified inspection of premium fire safety equipment for healthcare facilities, advanced restaurant and kitchen suppression installations, customized systems for mining camps and high-volume environments, and rugged suppression solutions for heavy vehicles and heavy-duty equipment. Each completed project demonstrates Prosafe's technical reliability, detailed engineering, and industry compliance, earning the trust of valued clients such as Diakonessenhuis, Newmont LLC, Rosebel LLC, McDonald's, Staatsolie, and SEMC.",
      paragraph2: "Across all implementations, Prosafe consistently delivers safety-driven fire protection systems that safeguard lives, facilities, and operations, from state-of-the-art clean agent suppression to rapid-response CO₂ installations and dry riser systems for high-rise firefighting effectiveness. Our proven track record of realized projects reflects both depth of experience and a client-centred approach to fire risk mitigation.",
      imageAlt1: "Buckeye Fire Equipment",
      imageAlt2: "Ansul Restaurant Fire Suppression Systems",
      imageAlt3: "Automatic Fire Suppression",
      imageAlt4: "CO2 Fire Suppression Systems",
      imageAlt5: "Dry Riser Systems",
      imageAlt6: "Fire Suppression Systems",
      imageAlt7: "Kitchen Fire Suppression Systems",
      imageAlt8: "Maritime Fire Suppression Systems",
      imageAlt9: "Restaurant Fire Suppression Systems",
      imageAlt10: "Vehicle & Heavy Equipment Fire Suppression",
      imageAlt11: "Vehicle & Heavy Equipment Fire Suppression - Newmont"
    },
    // Contact Page
    contact: {
      title: "Contact Us",
      subtitle: "Do you have questions about our fire protection services or would you like to request a free quote for fire suppression system installation? Feel free to contact us. We are ready to help you.",
      address: "Address",
      phone: "Phone",
      email: "Email",
      hours: "Opening Hours",
      hoursValue: "Mon - Fri: 08:00 - 17:00\nSat - Sun: Closed",
      formTitle: "Send us a message",
      name: "Name",
      emailLabel: "Email",
      phoneLabel: "Phone",
      company: "Company",
      subject: "Subject",
      message: "Message",
      submit: "Send Message",
      sending: "Sending...",
      attachment: "Attachment",
      chooseFile: "Choose file",
      success: "Thank you for your message! We will contact you as soon as possible.",
      selectSubject: "Select a subject",
      location: "Our Location",
      planRoute: "Plan route"
    },
    // Brandblussystemen Page
    brandblussystemen: {
      title: "FIRE EXTINGUISHER SYSTEMS",
      subtitle: "The first line of defense for your safety",
      paragraph1: "Effectively fighting an incipient fire requires not only speed but above all the right technology. At Prosafe Fire Protection N.V., we understand that no risk is the same. As a leading partner in fire protection in Suriname, we offer high-quality fire extinguisher systems that are immediately deployable when it really matters. From essential portable extinguishers for office environments to advanced fixed extinguishing installations for complex industrial applications; we provide professional installation that seamlessly connects to your specific business risks.",
      paragraph2: "Our approach goes beyond just delivery; we guarantee quality that meets the strictest international safety standards. By choosing Prosafe, you choose equipment that is designed for various scenarios, so that damage to property and danger to human lives are minimized. Protect what matters and ensure yourself a solution that works at the supreme moment. With our expertise in extinguishing technology and prevention, we build together on the business continuity and safety of your organization, today and tomorrow."
    },
    // Branddetectie Page
    branddetectie: {
      title: "FIRE DETECTION & ALARM SYSTEMS",
      subtitle: "Every Second Counts: Advanced Fire Detection for Maximum Safety",
      paragraph1: "In the event of an incipient fire, time is your most precious asset; a rapid response makes the difference between a minor incident and a major catastrophe. With the reliable fire detection systems from Prosafe Fire Protection N.V., you are assured of the earliest possible warning, 24 hours a day. As fire protection specialists in Suriname, we install smart technology that responds immediately to smoke or heat, saving you and your employees valuable time to bring yourself and your property to safety.",
      paragraph2: "We don't supply standard products, but a safety solution tailored to your risks. From strategic design and professional installation to essential periodic inspections, our certified experts guide you through the entire process. Choose Prosafe's professional fire protection services and protect the continuity of your business with systems that meet the strictest international safety standards."
    },
    // Onderhoud Page
    onderhoud: {
      title: "MAINTENANCE & INSPECTION",
      subtitle: "Trust Technology That Works When Every Second Counts",
      paragraph1: "Installing fire protection is just the first step; the guarantee that the system works when it really matters is what matters. Nothing is more dangerous than a false sense of security. Fire extinguishers and alarm systems that remain unused for years can malfunction in an emergency due to dust, loss of pressure, or technical defects. At Prosafe Fire Protection N.V., we understand that maintenance of fire extinguishers and detection systems is not an administrative obligation, but a life-saving necessity that makes the difference between a minor incident and a major disaster.",
      paragraph2: "Our team of certified experts takes care of that for you with our comprehensive fire protection services in Suriname. We not only inspect according to the checklist, but also thoroughly test your equipment for functionality and reliability, in accordance with the strictest international standards and local regulations. Whether it's a single extinguisher or a complex fire alarm system, we ensure proper inspections, clear reporting, and official certification. Our periodic maintenance not only ensures you meet your insurer's requirements but also, and more importantly, guarantees the continuity of your organization and the safety of your employees."
    },
    // Advies Page
    advies: {
      title: "CONSULTING & FIRE PREVENTION",
      subtitle: "Protecting What Matters Most",
      paragraph1: "True safety requires more than just hardware; it demands a strategic mindset and unwavering reliability. As Suriname's leading authority in fire protection, Prosafe Fire Protection N.V. bridges the gap between technical compliance and operational continuity. We don't just install equipment; we engineer peace of mind. Whether it is deploying state-of-the-art suppression systems or advanced detection alarms, our mission is to shield your people and assets against the unpredictable, ensuring your organization remains resilient in the face of risk.",
      paragraph2: "Our distinction lies in our expert consulting services. We understand that every facility carries unique vulnerabilities, which is why our certified specialists provide tailor-made risk analyses and prevention strategies that align with international safety standards. From safety audits to designing comprehensive evacuation plans, Prosafe transforms complex regulatory challenges into clear, actionable solutions. Partner with us to secure your legacy—because protecting your business means protecting your future."
    },
    // Noodverlichting Page
    noodverlichting: {
      title: "EMERGENCY LIGHTING & EVACUATION",
      subtitle: "Reliable emergency lighting designed to prevent panic and secure escape routes.",
      paragraph1: "In an emergency, when power fails or smoke obscures vision, confusion becomes the enemy. Functional emergency lighting is not just a regulatory requirement; it is a critical lifeline that guides people to safety. Prosafe Fire Protection N.V. ensures that your escape routes are instantly visible, minimizing panic and allowing for a rapid, orderly evacuation of your premises.",
      paragraph2: "We design and install comprehensive evacuation systems tailored to meet strict safety standards. From illuminated exit signs to strategic anti-panic lighting, our certified experts build systems you can trust. With our dedicated maintenance services, we ensure your equipment is always operational, protecting your people and ensuring your organization remains compliant."
    },
    // Subject Options
    subjects: {
      brandblussystemen: "Fire Extinguisher Systems",
      branddetectie: "Fire Detection & Alarm Systems",
      onderhoud: "Maintenance & Inspection",
      advies: "Consulting & Fire Prevention",
      noodverlichting: "Emergency Lighting & Evacuation",
      certificeringen: "Certifications",
      offerte: "Quote",
      vacatures: "Vacancies",
      anders: "Other"
    },
    // Shopping Cart
    cart: {
      popup: "Our online shop will be ready soon."
    },
    // Search
    search: {
      placeholder: "Search...",
      noResults: "No results found"
    },
    // Cookie Banner
    cookie: {
      message: "We use cookies to improve your experience on our website.",
      accept: "Accept",
      decline: "Decline"
    },
    vacatures: {
      title: "Vacancies",
      intro: "Prosafe Fire Protection is growing! We are looking for motivated professionals who want to contribute to fire safety in Suriname. See our current vacancies below.",
      interested: "Interested? Send your CV and motivation to:"
    }
  },
  nl: {
    // Navigation
    nav: {
      home: "Home",
      diensten: "Diensten",
      projecten: "Projecten",
      vacatures: "Vacatures",
      contact: "Contact",
      brandblussystemen: "Brandblussystemen",
      branddetectie: "Branddetectie & Alarmsystemen",
      onderhoud: "Onderhoud & Inspectie",
      advies: "Advies & Brandpreventie",
      noodverlichting: "Noodverlichting & Evacuatie"
    },
    // Visual Highlights
    visualHighlights: [
      "Brandblussers inspectie",
      "Brandveiligheid controle",
      "Brandbeveiliging apparatuur"
    ],
    // Hero
    hero: {
      headline: ["Professionele", "brandbeveiliging,", "vandaag en morgen."],
      description: "Toonaangevende brandbeveiliging Suriname. Proactief bewustzijn en verantwoordelijk handelen zijn de meest effectieve verdediging tegen brandgevaar.",
      cta: "OFFERTE"
    },
    // Company Intro
    companyIntro: {
      title: "PROSAFE FIRE PROTECTION N.V.",
      paragraph1: "Prosafe Fire Protection N.V. is het toonaangevende brandpreventiebedrijf in Suriname, gespecialiseerd in professionele brandbeveiligingsdiensten. Wij ondersteunen organisaties bij het beschermen van mensen, gebouwen en bedrijfscontinuïteit door middel van betrouwbare en gecertificeerde brandveiligheidssystemen.",
      paragraph2: "Met een deskundig team en jarenlange ervaring in brandblussysteem installatie en brandblussers onderhoud bieden wij oplossingen die voldoen aan internationale normen en lokale regelgeving. Onze aanpak is praktisch, klantgericht en gericht op langdurige veiligheid."
    },
    // Trusted Clients
    trustedClients: {
      title: "ONZE VERTROUWDE KLANTEN"
    },
    // Why Prosafe
    whyProsafe: {
      title: "WAAROM PROSAFE FIRE PROTECTION?",
      reasons: [
        "Ervaren en gecertificeerde brandbeveiligingsspecialisten",
        "Brandblussysteem installatie op maat",
        "Snelle service en brandblussers onderhoud ondersteuning",
        "Focus op brandpreventie en bedrijfscontinuïteit"
      ]
    },
    // Mission & Vision
    missionVision: {
      missionTitle: "ONZE MISSIE",
      missionText: "Het leveren van hoogwaardige brandbeveiligingsdiensten Suriname die risico's minimaliseren en bijdragen aan een veilige werkomgeving voor iedereen door expert branddetectiesystemen en brandblussysteem oplossingen.",
      visionTitle: "ONZE VISIE",
      visionText: "Een samenleving waarin brandbeveiliging Suriname vanzelfsprekend is en organisaties vertrouwen hebben in hun branddetectiesystemen en brandblussysteem oplossingen."
    },
    // Core Values
    coreValues: {
      title: "Onze Kernwaarden",
      values: [
        { title: "Veiligheid", description: "Brandpreventie is altijd onze hoogste prioriteit" },
        { title: "Betrouwbaarheid", description: "Vertrouwde brandbeveiligingsdiensten - afspraak is afspraak" },
        { title: "Professionaliteit", description: "Expert branddetectiesystemen, gecertificeerd en transparant" },
        { title: "Kwaliteit", description: "Duurzame en bewezen brandblussysteem installatie" }
      ]
    },
    // CTA Section
    cta: {
      headline: ["NEEM", "VANDAAG", "NOG", "CONTACT MET ONS OP"],
      headlineFull: "NEEM VANDAAG NOG CONTACT MET ONS OP",
      description: "Vraag een vrijblijvende offerte aan voor brandblussysteem installatie en brandblussers onderhoud.",
      button: "CONTACT"
    },
    // CTA for Brandblussystemen page
    ctaBrandblussystemen: {
      headline: "NEEM VANDAAG NOG CONTACT MET ONS OP",
      description: "voor een offerte over brandbeveiligingsdiensten Suriname",
      button: "OFFERTE AANVRAGEN"
    },
    // Footer
    footer: {
      subscriptionText: "Blijf geïnformeerd over brandbeveiliging Suriname. Abonneer u op onze nieuwsbrief voor updates over brandpreventie, branddetectiesystemen en praktische brandveiligheid inzichten—rechtstreeks in uw inbox.",
      copyright: "Copyright © 2026 Prosafe Fire Protection. All rights reserved."
    },
    // Projects Page
    projects: {
      title: "PROJECTEN",
      subtitle: "Demonstratie van onze toewijding aan veiligheid door succesvolle brandbeveiligingsimplementaties.",
      paragraph1: "Ons projectportfolio benadrukt het vermogen van Prosafe om op maat gemaakte brandbeveiligingssystemen te leveren die voldoen aan strenge prestatienormen en klantbehoeften. Dit omvat de verkoop en gecertificeerde inspectie van premium brandveiligheidsapparatuur voor zorginstellingen, geavanceerde restaurant- en keukenblusinstallaties, op maat gemaakte systemen voor mijnbouwkampen en omgevingen met hoog volume, en robuuste blusoplossingen voor zware voertuigen en zwaar materieel. Elk voltooid project demonstreert de technische betrouwbaarheid, gedetailleerde engineering en naleving van industrienormen van Prosafe, waardoor het vertrouwen van gewaardeerde klanten zoals Diakonessenhuis, Newmont LLC, Rosebel LLC, McDonald's, Staatsolie en SEMC wordt verdiend.",
      paragraph2: "Bij alle implementaties levert Prosafe consequent veiligheidsgerichte brandbeveiligingssystemen die levens, faciliteiten en operaties beschermen, van ultramoderne schone blusmiddelen tot snelreactie CO₂-installaties en droge stijgleidingsystemen voor effectieve brandbestrijding in hoogbouw. Onze bewezen staat van dienst van gerealiseerde projecten weerspiegelt zowel diepgaande ervaring als een klantgerichte benadering van brandrisicovermindering.",
      imageAlt1: "Buckeye Brandblussapparatuur",
      imageAlt2: "Ansul Restaurant Brandblussystemen",
      imageAlt3: "Automatische Brandblussystemen",
      imageAlt4: "CO2 Brandblussystemen",
      imageAlt5: "Droge Stijgleidingsystemen",
      imageAlt6: "Brandblussystemen",
      imageAlt7: "Keuken Brandblussystemen",
      imageAlt8: "Maritieme Brandblussystemen",
      imageAlt9: "Restaurant Brandblussystemen",
      imageAlt10: "Voertuig & Zwaar Materieel Brandblussystemen",
      imageAlt11: "Voertuig & Zwaar Materieel Brandblussystemen - Newmont"
    },
    // Contact Page
    contact: {
      title: "Neem Contact Op",
      subtitle: "Heeft u vragen over onze brandbeveiligingsdiensten of wilt u een vrijblijvende offerte aanvragen voor brandblussysteem installatie? Neem gerust contact met ons op. Wij staan klaar om u te helpen.",
      address: "Adres",
      phone: "Telefoon",
      email: "E-mail",
      hours: "Openingstijden",
      hoursValue: "Ma - Vr: 08:00 - 17:00\nZa - Zo: Gesloten",
      formTitle: "Stuur ons een bericht",
      name: "Naam",
      emailLabel: "E-mail",
      phoneLabel: "Telefoon",
      company: "Bedrijf",
      subject: "Onderwerp",
      message: "Bericht",
      submit: "Verstuur Bericht",
      sending: "Verzenden...",
      attachment: "Bijlage",
      chooseFile: "Bestand kiezen",
      success: "Bedankt voor uw bericht! Wij nemen zo snel mogelijk contact met u op.",
      selectSubject: "Selecteer een onderwerp",
      location: "Onze Locatie",
      planRoute: "Route plannen"
    },
    // Brandblussystemen Page
    brandblussystemen: {
      title: "BRANDBLUSSYSTEMEN",
      subtitle: "De eerste verdedigingslinie voor uw veiligheid",
      paragraph1: "Een beginnende brand effectief bestrijden vereist niet alleen snelheid, maar bovenal de juiste technologie. Bij Prosafe Fire Protection N.V. begrijpen we dat geen enkel risico hetzelfde is. Als toonaangevende partner in brandbeveiliging in Suriname, bieden wij hoogwaardige brandblussystemen die direct inzetbaar zijn wanneer het er echt toe doet. Van essentiële draagbare blussers voor kantooromgevingen tot geavanceerde vaste blusinstallaties voor complexe industriële toepassingen; wij verzorgen een professionele installatie die naadloos aansluit op uw specifieke bedrijfsrisico's.",
      paragraph2: "Onze aanpak gaat verder dan enkel levering; wij garanderen kwaliteit die voldoet aan de strengste internationale veiligheidsnormen. Door te kiezen voor Prosafe, kiest u voor apparatuur die berekend is op diverse scenario's, zodat schade aan eigendommen en gevaar voor mensenlevens tot een minimum worden beperkt. Bescherm wat telt en verzeker uzelf van een oplossing die werkt op het moment suprême. Met onze expertise in blustechniek en preventie bouwen we samen aan de bedrijfscontinuïteit en veiligheid van uw organisatie, vandaag en morgen."
    },
    // Branddetectie Page
    branddetectie: {
      title: "BRANDDETECTIE & ALARMSYSTEMEN",
      subtitle: "Elke seconde telt: geavanceerde branddetectie voor maximale veiligheid",
      paragraph1: "Bij een beginnende brand is tijd uw kostbaarste bezit; een snelle reactie maakt het verschil tussen een klein incident en een grote catastrofe. Met de betrouwbare branddetectiesystemen van Prosafe Fire Protection N.V. bent u verzekerd van de vroegst mogelijke waarschuwing, 24 uur per dag. Als brandveiligheidsspecialisten in Suriname installeren wij slimme technologie die direct reageert op rook of hitte, waardoor u en uw medewerkers waardevolle tijd besparen om uzelf en uw eigendommen in veiligheid te brengen.",
      paragraph2: "Wij leveren geen standaardproducten, maar een veiligheidsoplossing op maat van uw risico's. Van strategisch ontwerp en professionele installatie tot essentiële periodieke inspecties, onze gecertificeerde experts begeleiden u door het gehele proces. Kies voor de professionele brandbeveiligingsdiensten van Prosafe en bescherm de continuïteit van uw bedrijf met systemen die voldoen aan de strengste internationale veiligheidsnormen."
    },
    // Onderhoud Page
    onderhoud: {
      title: "ONDERHOUD & INSPECTIE",
      subtitle: "Vertrouw op technologie die werkt wanneer elke seconde telt",
      paragraph1: "Het installeren van brandbeveiliging is slechts de eerste stap; de garantie dat het systeem werkt wanneer het er echt toe doet, is wat telt. Niets is gevaarlijker dan een vals gevoel van veiligheid. Brandblussers en alarmsystemen die jarenlang ongebruikt blijven, kunnen bij een noodgeval defect raken door stof, drukverlies of technische gebreken. Bij Prosafe Fire Protection N.V. begrijpen wij dat onderhoud van brandblussers en detectiesystemen geen administratieve verplichting is, maar een levensreddende noodzaak die het verschil maakt tussen een klein incident en een grote ramp.",
      paragraph2: "Ons team van gecertificeerde experts neemt dat voor u uit handen met onze uitgebreide brandbeveiligingsdiensten in Suriname. Wij inspecteren niet alleen volgens de checklist, maar testen uw apparatuur ook grondig op functionaliteit en betrouwbaarheid, in overeenstemming met de strengste internationale normen en lokale regelgeving. Of het nu gaat om een enkele brandblusser of een complex brandalarmsysteem, wij zorgen voor deugdelijke inspecties, duidelijke rapportages en officiële certificering. Ons periodiek onderhoud zorgt er niet alleen voor dat u voldoet aan de eisen van uw verzekeraar, maar garandeert vooral de continuïteit van uw organisatie en de veiligheid van uw medewerkers."
    },
    // Advies Page
    advies: {
      title: "ADVIES & BRANDPREVENTIE",
      subtitle: "Bescherm wat het belangrijkst is",
      paragraph1: "Echte veiligheid vereist meer dan alleen hardware; het vraagt om een strategische mindset en onwankelbare betrouwbaarheid. Als toonaangevende autoriteit op het gebied van brandbeveiliging in Suriname, overbrugt Prosafe Fire Protection N.V. de kloof tussen technische naleving en operationele continuïteit. Wij installeren niet zomaar apparatuur; wij creëren gemoedsrust. Of het nu gaat om het inzetten van ultramoderne blussystemen of geavanceerde detectiealarmen, onze missie is om uw mensen en bezittingen te beschermen tegen het onvoorspelbare, zodat uw organisatie veerkrachtig blijft tegenover risico's.",
      paragraph2: "Ons onderscheid ligt in onze deskundige adviesdiensten. Wij begrijpen dat elke faciliteit unieke kwetsbaarheden heeft, daarom bieden onze gecertificeerde specialisten op maat gemaakte risicoanalyses en preventiestrategieën die aansluiten bij internationale veiligheidsnormen. Van veiligheidsaudits tot het ontwerpen van uitgebreide evacuatieplannen, Prosafe transformeert complexe regelgevingsuitdagingen in duidelijke, uitvoerbare oplossingen. Werk met ons samen om uw erfgoed te beschermen—want het beschermen van uw bedrijf betekent het beschermen van uw toekomst."
    },
    // Noodverlichting Page
    noodverlichting: {
      title: "NOODVERLICHTING & EVACUATIE",
      subtitle: "Betrouwbare noodverlichting ontworpen om paniek te voorkomen en vluchtroutes te beveiligen.",
      paragraph1: "In een noodsituatie, wanneer de stroom uitvalt of rook het zicht belemmert, wordt verwarring de vijand. Functionele noodverlichting is niet slechts een wettelijke vereiste; het is een kritieke reddingslijn die mensen naar veiligheid leidt. Prosafe Fire Protection N.V. zorgt ervoor dat uw vluchtroutes direct zichtbaar zijn, waardoor paniek wordt geminimaliseerd en een snelle, ordelijke evacuatie van uw pand mogelijk wordt.",
      paragraph2: "Wij ontwerpen en installeren uitgebreide evacuatiesystemen op maat om te voldoen aan strikte veiligheidsnormen. Van verlichte nooduitgangborden tot strategische antipaniekverlichting, onze gecertificeerde experts bouwen systemen waarop u kunt vertrouwen. Met onze toegewijde onderhoudsdiensten zorgen wij ervoor dat uw apparatuur altijd operationeel is, waardoor uw mensen worden beschermd en uw organisatie aan de regelgeving blijft voldoen."
    },
    // Subject Options
    subjects: {
      brandblussystemen: "Brandblussystemen",
      branddetectie: "Branddetectie & Alarmsystemen",
      onderhoud: "Onderhoud & Inspectie",
      advies: "Advies & Brandpreventie",
      noodverlichting: "Noodverlichting & Evacuatie",
      certificeringen: "Certificeringen",
      offerte: "Offerte",
      vacatures: "Vacatures",
      anders: "Anders"
    },
    // Shopping Cart
    cart: {
      popup: "Onze online shop is binnenkort beschikbaar."
    },
    // Search
    search: {
      placeholder: "Zoeken...",
      noResults: "Geen resultaten gevonden"
    },
    // Cookie Banner
    cookie: {
      message: "Wij gebruiken cookies om uw ervaring op onze website te verbeteren.",
      accept: "Accepteren",
      decline: "Weigeren"
    },
    vacatures: {
      title: "Vacatures",
      intro: "Prosafe Fire Protection groeit! Wij zijn op zoek naar gemotiveerde professionals die willen bijdragen aan brandveiligheid in Suriname. Bekijk hieronder onze actuele vacatures.",
      interested: "Interesse? Stuur je CV en motivatie naar:"
    }
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('language');
    return saved || 'en';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, translations: translations[language] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
